// import { EventEmitter } from 'fbemitter';
// const emitter = new EventEmitter();
let finishedArray = [];

const FaqStore = {
  parseFaqs(json) {
    const sorted = [];
    const tagsArr = [];

    for (let i = 0; i < json.length; i++) {
      const thisPost = json[i];
      const tags = thisPost.tags.split(", ");

      for (let t = 0; t < tags.length; t++) {
        const tag = tags[t];
        if (!sorted[tag]) {
          sorted[tag] = [];
          tagsArr.push(tag);
        }
        sorted[tag].push(thisPost);
      }
    }
    for (let i = 0; i < tagsArr.length; i++) {
      // console.log(sorted[tagsArr[i]]);
      const catPosts = this.sortArrayPosts(sorted[tagsArr[i]]);
      const organizedTag = {
        'tag' : tagsArr[i],
        'posts' : catPosts
      }
      finishedArray.push(organizedTag);
    }

    finishedArray = this.sortArrayCategories(finishedArray);

    return finishedArray;
  },

  sortArrayCategories(arr) {
    arr.sort(function(a, b) {
      var keyA = a.tag,
          keyB = b.tag;
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });

    return arr;
  },
  
  sortArrayPosts(arr) {
    arr.sort(function(a, b) {
      var keyA = a.title,
          keyB = b.title;
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });

    return arr;
  },


  // addListener(eventType: string, fn: Function) {
  //   return emitter.addListener(eventType, fn);
  // },
};

export default FaqStore;
